var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 129.61 129.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ddfec7;}.cls-3{fill:#30b524;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.39 -0.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.86,
    y: 46.77,
    width: 50.91,
    height: 38
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    className: "cls-2",
    cx: 64.81,
    cy: 64.81,
    r: 64.81
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    className: "cls-3",
    cx: 64.3,
    cy: 65.31,
    r: 51.24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    className: "cls-5",
    d: "M79.38,48.55,57.86,70.07l-8.61-8.61a6.08,6.08,0,0,0-8.6,8.61L53.56,83a6.08,6.08,0,0,0,8.6,0h0L88,57.16a6.09,6.09,0,1,0-8.61-8.61",
    transform: "translate(-0.39 -0.31)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.264601bcf970058995b315c16a48720c.svg";
export { ForwardRef as ReactComponent };